import { Box, Typography } from '@mui/material';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import TypeCheckbox from '../form/form-fields/TypeCheckbox';

export const StepInlineAttachments = ({
  dataCollection,
  updateDataCollection,
  updateValidation,
}) => {
  const { t } = useTranslation();

  const [usedPositionTypes, setUsedPositionTypes] = useState([]);

  const attachmentTypes = [
    {
      label: t('HOAI Calculation'),
      key: 'hoaiCalculation',
      positionKey: 'hoaiPhase',
    },
    {
      label: t('Timesheet'),
      key: 'timesheet',
      checkFn: (positions) =>
        positions.some(
          (p) => p.timeTrackingIds && p.timeTrackingIds.length > 0
        ),
    },
  ];

  function getPositionTypes(positions) {
    const types = [];
    positions.forEach((position) => {
      if (position.type && !types.includes(position.type)) {
        types.push(position.type);
      }
    });
    return types;
  }

  function hasTimeTrackings(positions) {
    return positions.some(
      (p) => p.timeTrackingIds && p.timeTrackingIds.length > 0
    );
  }

  useEffect(() => {
    updateValidation(true);
    if (dataCollection?.positions) {
      setUsedPositionTypes(getPositionTypes(dataCollection?.positions));
    }
  }, [dataCollection?.positions]);

  function handleAttachmentChange(key) {
    const current = dataCollection?.inlineAttachments || [];
    const newInlineAttachments = current.includes(key)
      ? current.filter((k) => k !== key)
      : [...current, key];
    updateDataCollection({ inlineAttachments: newInlineAttachments });
  }

  return (
    <Box className="flex flex-col gap-2">
      <Typography fontWeight={500} fontSize={16}>
        {t('Which attachments should be automatically generated and sent?')}
      </Typography>
      {attachmentTypes.map((type) => {
        // Check if this attachment type should be shown
        const shouldShow = type.checkFn
          ? type.checkFn(dataCollection?.positions || [])
          : usedPositionTypes.includes(type.positionKey);

        if (shouldShow) {
          return (
            <TypeCheckbox
              key={type.key}
              field={type}
              dataCollection={{
                [type.key]: dataCollection?.inlineAttachments?.includes(
                  type.key
                ),
              }}
              updateValidationOnChange={() => handleAttachmentChange(type.key)}
            />
          );
        }
        return null;
      })}
    </Box>
  );
};

export function hasInlineAttachments(positions) {
  if (!positions) return false;

  const attachmentPositionTypes = ['hoaiPhase'];

  // Check for position types that require attachments
  const hasTypeAttachments = positions.some((position) =>
    attachmentPositionTypes.includes(position.type)
  );

  // Check for positions with time tracking IDs (timesheet attachment)
  const hasTimeTrackings = positions.some(
    (position) =>
      position.timeTrackingIds && position.timeTrackingIds.length > 0
  );

  return hasTypeAttachments || hasTimeTrackings;
}
